import { G } from '@mobily/ts-belt';

import { B2bEmployeeTaigaPlan } from '@Common/types/bo/b2b/employees/taiga_plans';
import { BoArbitrage } from '@Common/types/bo/b2b/individual_operations/arbitrage';

import { PlanSelectChoice } from '@sh4res/bo-common/components/B2bVoluntaryPayment/components/PlanSelectInput';

export type ArbitrageRow = {
  saving_plan_id: number | string | null;
  instrument_id: number | null;
  amount: number | null;
  plan_data: PlanSelectChoice | null;
  taiga_plan: B2bEmployeeTaigaPlan | null;
};

export type ArbitrageFormData = {
  b2b_employee_id: number | null;
  sources?: ArbitrageRow[];
  targets?: ArbitrageRow[];
  notify_employee?: boolean;
  reason?: string;
  confirm_accuracy?: string[];
};

const toAllocations = (rows: ArbitrageRow[] = []) =>
  rows.flatMap((row) =>
    row.saving_plan_id === null || row.amount === null
      ? []
      : [
          {
            saving_plan_id: row.saving_plan_id,
            instrument_id: row.instrument_id,
            amount: row.amount,
          },
        ],
  );

export const emptyArbitrageRow = (): ArbitrageRow => ({
  saving_plan_id: null,
  instrument_id: null,
  amount: null,
  plan_data: null,
  taiga_plan: null,
});

export const sumArbitrageRows = (rows: ArbitrageRow[] = []) =>
  rows.reduce((total, row) => total + (row.amount ?? 0), 0);

export function buildArbitrageBody(data: ArbitrageFormData): BoArbitrage {
  if (G.isNullable(data.b2b_employee_id)) {
    throw new Error('An employee is required to build an arbitrage');
  }

  return {
    b2b_employee_id: data.b2b_employee_id,
    notify_employee: data.notify_employee ?? true,
    arbitrages: [
      {
        sources: toAllocations(data.sources),
        targets: toAllocations(data.targets),
      },
    ],
  };
}
